import script from "./ProblemCancelLeavePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProblemCancelLeavePopup.vue?vue&type=script&setup=true&lang=ts"

import "./ProblemCancelLeavePopup.vue?vue&type=style&index=0&id=58215b4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58215b4c"]])

export default __exports__